import { ReactElement } from 'react';
import { Field as BaseField, FieldProps, FieldRenderProps } from 'react-final-form';

import { IBaseFieldProps } from './Field.types';

export function Field<
  FieldValue = any,
  RP extends FieldRenderProps<FieldValue, T> = FieldRenderProps<FieldValue, HTMLElement>,
  T extends HTMLElement = HTMLElement
>(props: IBaseFieldProps<FieldValue, RP, T>): ReactElement {
  const { subscription = {}, isNeedTrim = false, ...rest } = props;
  const fieldProps: Partial<FieldProps<FieldValue, RP, T>> = {
    validateFields: [],
    subscription: {
      data: false,
      initial: true,
      length: false,
      active: true,
      dirty: true,
      dirtySinceLastSubmit: false,
      error: true,
      invalid: true,
      modified: true,
      modifiedSinceLastSubmit: false,
      pristine: false,
      submitError: false,
      submitFailed: false,
      submitSucceeded: false,
      submitting: false,
      touched: false,
      valid: true,
      validating: true,
      value: true,
      visited: false,
      ...subscription,
    },
  };

  if (isNeedTrim) {
    // helps detect is dirty
    fieldProps.isEqual = (a: any, b: any): boolean => {
      if (!a && !b) {
        return true;
      }

      if (typeof a === 'undefined' || typeof b === 'undefined') {
        return false;
      }

      return a.trim() === b.trim();
    };
  }

  return (
    <BaseField
      {...fieldProps}
      {...rest}
    />
  );
}
